module.exports = __webpack_public_path__ + "@/assets/img/cursoIA-robot.7987773f.png";